import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import { US_UUID } from "constants/regAgent";
import { useGetCountryStatesQuery } from "store/apis/teamSetting";
import { FILTER_STATE_REGISTRATIONS } from "../Task1120FilterOptions";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";

export const TaskStateRegistrationColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  const { data: states } = useGetCountryStatesQuery({
    countryId: US_UUID,
  });

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>State Registrations</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_STATE_REGISTRATIONS}
        options={
          states?.map((state) => ({
            value: state.state_id,
            label: state.name,
          })) || []
        }
        selected={values.STATE_REGISTRATIONS || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
